import { PadBase } from './base/pad-base';

export class Pad extends PadBase { }